module.exports = __webpack_public_path__ + "img/4.8eb6747f.jpg";